import React, { useState, useEffect } from "react";
import styles from "./ad_styles";

function LoginForm({ onLogin }) {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await fetch("/api/admin/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: credentials.username, password: credentials.password }),
      });
      if (response.ok) {
        const data = await response.json();
        localStorage.setItem("admin_token", data.access_token);
        onLogin(data.access_token);
      } else {
        alert("Invalid credentials");
      }
    } catch {
      alert("Login failed");
    }
    setLoading(false);
  };
  
  return (
    <div style={styles.body}>
      <div style={styles.loginCard}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h2 style={{ color: '#0f5132', marginBottom: '0.5rem' }}>🔐 Admin Login</h2>
          <p style={{ color: '#64748b' }}>Saudi British Network</p>
        </div>
        
        <form onSubmit={handleLogin}>
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Username</label>
            <input 
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({...credentials, username: e.target.value})}
              style={styles.formInput}
              placeholder="Enter username"
              required
            />
          </div>
          
          <div style={styles.formGroup}>
            <label style={styles.formLabel}>Password</label>
            <input 
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({...credentials, password: e.target.value})}
              style={styles.formInput}
              placeholder="Enter password"
              required
            />
          </div>
          
          <button 
            type="submit" 
            style={{
              ...styles.primaryButton,
              width: '100%',
              justifyContent: 'center',
              marginTop: '1rem'
            }}
            disabled={loading}
          >
            {loading ? <span style={styles.loadingSpinner}></span> : '🚀 Login'}
          </button>
        </form>
      </div>
    </div>
  );
};
export default LoginForm;